import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconHome: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill || '#262626';

  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7071 1.29289C12.3166 0.902369 11.6834 0.902369 11.2929 1.29289L3.29325 9.29254L3.29254 9.29325L1.29289 11.2929C0.902369 11.6834 0.902369 12.3166 1.29289 12.7071C1.68342 13.0976 2.31658 13.0976 2.70711 12.7071L3 12.4142V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V12.4142L21.2929 12.7071C21.6834 13.0976 22.3166 13.0976 22.7071 12.7071C23.0976 12.3166 23.0976 11.6834 22.7071 11.2929L12.7071 1.29289Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconHome;
